<template>
  <el-form ref="formRef" label-width="110px" :model="form" :rules="rules">
    <el-form-item label="媒体" prop="mediaId">
      <el-select style="width: 100%" v-model="form.mediaId" :disabled="isUpdate" filterable>
        <el-option v-for="item in [{ mediaId: 16, name: '腾讯' }]" :key="item.mediaId" :label="item.name" :value="item.mediaId">
        </el-option>
      </el-select>
    </el-form-item>

    <slot name="account" :account-list="accountList">
      <el-form-item label="管家账号" prop="adAccountId">
        <el-select style="width: 100%" v-model="form.adAccountId" :disabled="isUpdate" filterable>
          <el-option v-for="item in accountList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>
    </slot>

    <slot name="tag-name"></slot>
  </el-form>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { adAccount } from '@/api/common.model'
// eslint-disable-next-line
const props = defineProps({
  form: {
    required: true,
    type: Object
  }
})

const formRef = ref(null)
const accountList = ref([])

const isUpdate = computed(() => {
  return !!props.form.tagId
})

adAccount({ mediaId: props.form.mediaId, accountType: 1 }).then((data) => {
  accountList.value = Array.isArray(data) ? data : []
})

const rules = {
  mediaId: [{ required: true, message: '请选择媒体', trigger: 'change' }],
  adAccountIds: [
    { required: true, message: '请选择管家账号', trigger: 'change' },
    { type: 'array', min: 1, message: '请选择管家账号', trigger: 'change' }
  ],
  adAccountId: [{ required: true, message: '请选择管家账号', trigger: 'change' }],
  tagName: [
    { required: true, message: '请输入标签名称', trigger: 'change' },
    { min: 1, max: 10, message: '标签名称长度为1-10个字符', trigger: 'change' }
  ]
}

// eslint-disable-next-line
defineExpose({
  validate() {
    return formRef.value.validate()
  },
  getForm() {
    return props.form
  }
})
</script>

<style scoped lang="scss"></style>
